import { makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { ContentProps, DialogType } from 'src/redux/types/redux.types';
import { appendPropsToChildren } from 'src/utils/functions/d.utils';

interface Props {
  type: DialogType;
  content: React.FunctionComponentElement<ContentProps>;
  data?: any;
  onClose: React.MouseEventHandler<any>;
  onConfirm?: React.MouseEventHandler<any>;
  isButtonDisabled?: boolean;
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      width: 'fit-content',
      ['@media (max-width: 500px)']: {
        width: '100%',
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // paddingTop: 30,
      // paddingBottom: 30,
      margin: '0 auto',
    },
  };
});

export const BuiltInDialog: FC<Props> = ({ type, content, onClose, onConfirm }) => {
  const classes = useStyles();

  const contentWithProps = appendPropsToChildren(content, {
    appProps: { onClose, onConfirm, type },
  });

  return (
    <>
      <div className={classes.root}>
        <div className={classes.content}>{contentWithProps}</div>
      </div>
    </>
  );
};
